// PARAQTA — Жаңа Landing (миссиямен үндес маркетингтік бет).
// Self-contained: барлық кластар `nl-` префиксімен, CSS айнымалылары `.nl-root`-қа
// scope-телген (бүкіл app стильдерімен қақтығыспау + тема режимінен тәуелсіз light).
// CTA-лар data-action="show-login" → Telegram login modal.

// Сандарды әдемі форматтау (бос орынмен бөлу, бет саны үшін «М»).
const sp = (n) => Number(n || 0).toLocaleString('ru-RU').replace(/[ ,]/g, ' ');
const fmtPages = (n) => {
  n = Number(n) || 0;
  if (n >= 1e6) return (n / 1e6).toFixed(1).replace('.', ',') + 'М';
  return sp(n);
};

export function renderNewLanding(stats) {
  const users = sp(stats?.users);
  const books = sp(stats?.books);
  const pages = fmtPages(stats?.total_pages);

  return `
<style>
  .nl-root{
    --bg:#F7F2EA; --card:#FFFFFF; --ink:#1C1A16;
    --ac:#8B5E34; --gold:#C9A96E; --gn:#3A5C3C;
    --line:rgba(28,26,22,.08);
    --muted:rgba(28,26,22,.62);
    --soft:rgba(28,26,22,.5);
    max-width:480px;margin:0 auto;background:var(--bg);min-height:100vh;
    font-family:'Onest',sans-serif;color:var(--ink);line-height:1.6;
    -webkit-font-smoothing:antialiased;
  }
  .nl-outer{background:#EFE8DB;min-height:100vh;}
  .nl-root *{margin:0;padding:0;box-sizing:border-box;}

  /* Nav */
  .nl-nav{position:sticky;top:0;z-index:50;display:flex;align-items:center;justify-content:space-between;
       padding:14px 18px;background:rgba(247,242,234,.92);backdrop-filter:blur(10px);
       border-bottom:.5px solid var(--line);}
  .nl-nav-logo{font-family:'PT Serif',Georgia,serif;font-size:18px;font-weight:700;letter-spacing:.5px;color:var(--ink);}
  .nl-nav-cta{padding:8px 16px;background:var(--ac);color:#fff;border:none;border-radius:999px;
           font-size:12.5px;font-weight:600;cursor:pointer;font-family:'Onest',sans-serif;}

  /* Hero */
  .nl-hero{text-align:center;padding:44px 26px 36px;position:relative;overflow:hidden;
        background:radial-gradient(120% 70% at 50% 0%,#FBF7EF 0%,#F7F2EA 60%);}
  .nl-hero-candle{width:110px;height:146px;margin:0 auto 26px;position:relative;}
  .nl-hero-glow{position:absolute;top:-10px;left:50%;transform:translateX(-50%);width:160px;height:160px;
             background:radial-gradient(circle,rgba(233,169,73,.4) 0%,transparent 65%);pointer-events:none;}
  .nl-hero-eyebrow{font-size:11px;letter-spacing:2px;color:var(--ac);font-weight:600;margin-bottom:14px;}
  .nl-hero-title{font-family:'PT Serif',Georgia,serif;font-size:31px;font-weight:700;line-height:1.22;
              margin-bottom:16px;letter-spacing:-.2px;}
  .nl-hero-title em{font-style:italic;color:var(--ac);}
  .nl-hero-sub{font-size:15.5px;font-weight:400;color:var(--muted);max-width:320px;margin:0 auto 26px;
            line-height:1.62;}
  .nl-hero-cta{display:inline-flex;align-items:center;gap:8px;padding:15px 30px;background:var(--ac);
            color:#fff;border:none;border-radius:999px;font-size:15px;font-weight:700;cursor:pointer;
            font-family:'Onest',sans-serif;box-shadow:0 8px 28px rgba(139,94,52,.22);
            transition:transform .12s ease;}
  .nl-hero-cta:active{transform:scale(.96);}
  .nl-hero-trust{font-size:12px;color:var(--soft);margin-top:12px;font-weight:500;}
  /* Secondary CTA: алдымен кітапханаға көз сал */
  .nl-hero-sec{display:inline-flex;align-items:center;gap:6px;margin-top:14px;padding:10px 18px;
            background:transparent;color:var(--ac);border:1.2px solid rgba(139,94,52,.32);
            border-radius:999px;font-size:13.5px;font-weight:600;cursor:pointer;
            font-family:'Onest',sans-serif;transition:background .15s ease;}
  .nl-hero-sec:hover{background:rgba(139,94,52,.06);}
  .nl-hero-sec:active{transform:scale(.96);}
  /* Nav: екінші link (Кітапхана) */
  .nl-nav-right{display:flex;align-items:center;gap:10px;}
  .nl-nav-link{padding:8px 12px;background:transparent;color:var(--ink);border:none;cursor:pointer;
            font-size:13px;font-weight:600;font-family:'Onest',sans-serif;border-radius:999px;
            transition:background .15s ease;}
  .nl-nav-link:hover{background:rgba(139,94,52,.08);}

  /* Stats */
  .nl-stats{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;padding:0 18px 8px;margin-top:8px;}
  .nl-stat{text-align:center;padding:14px 6px;}
  .nl-stat-num{font-family:'PT Serif',Georgia,serif;font-size:24px;font-weight:700;color:var(--ac);line-height:1;}
  .nl-stat-lbl{font-size:11px;color:var(--muted);margin-top:5px;font-weight:500;}

  /* Section base */
  .nl-sec{padding:34px 26px;}
  .nl-sec-eyebrow{display:block;width:fit-content;margin:0 auto 14px;
               font-size:12px;letter-spacing:.3px;color:var(--ac);font-weight:700;
               padding:6px 16px;border-radius:999px;
               background:rgba(201,169,110,.2);border:.5px solid rgba(201,169,110,.45);}
  .nl-sec-title{font-family:'PT Serif',Georgia,serif;font-size:24px;font-weight:700;line-height:1.25;
             text-align:center;margin-bottom:22px;}
  .nl-sec-title em{font-style:italic;color:var(--ac);}
  .nl-sec-lead{text-align:center;font-size:14.5px;color:var(--muted);max-width:320px;margin:0 auto 18px;line-height:1.6;}

  /* Mission */
  .nl-mission{background:linear-gradient(160deg,#FBF7EF,#F1E9D8);border-top:.5px solid var(--line);
           border-bottom:.5px solid var(--line);padding:40px 30px;text-align:center;}
  .nl-mission-text{font-family:'PT Serif',Georgia,serif;font-style:italic;font-size:20px;line-height:1.55;
                color:var(--ink);max-width:330px;margin:0 auto;}
  .nl-mission-text b{color:var(--ac);font-style:normal;}
  .nl-mission-sig{margin-top:18px;font-size:13px;color:var(--muted);font-weight:500;}

  /* Steps */
  .nl-steps{display:flex;flex-direction:column;gap:12px;}
  .nl-step{display:flex;align-items:flex-start;gap:14px;background:var(--card);border:.5px solid var(--line);
        border-radius:16px;padding:16px;}
  .nl-step-ico{width:46px;height:46px;border-radius:13px;flex-shrink:0;
            background:linear-gradient(135deg,rgba(201,169,110,.25),rgba(139,94,52,.06));
            display:flex;align-items:center;justify-content:center;font-size:22px;}
  .nl-step-body h4{font-family:'PT Serif',Georgia,serif;font-size:16.5px;font-weight:700;margin-bottom:3px;}
  .nl-step-body p{font-size:13.5px;color:var(--muted);line-height:1.5;}

  /* Feed preview */
  .nl-feed-prev{background:var(--card);border:.5px solid var(--line);border-radius:16px;padding:16px;margin-top:8px;}
  .nl-fp-row{display:flex;gap:10px;align-items:flex-start;padding:10px 0;border-bottom:.5px solid var(--line);}
  .nl-fp-row:last-child{border-bottom:none;}
  .nl-fp-av{width:32px;height:32px;border-radius:50%;flex-shrink:0;
         background:linear-gradient(135deg,#C9A96E,#8B5E34);color:#fff;display:flex;align-items:center;
         justify-content:center;font-size:12px;font-weight:600;}
  .nl-fp-mid{flex:1;}
  .nl-fp-name{font-size:12.5px;font-weight:600;}
  .nl-fp-book{font-size:11.5px;color:var(--ac);margin-bottom:3px;font-weight:500;}
  .nl-fp-text{font-size:13px;color:var(--muted);line-height:1.5;}
  .nl-fp-note{text-align:center;font-size:13px;color:var(--ac);margin-top:14px;font-weight:600;}

  /* Value */
  .nl-vals{display:flex;flex-direction:column;gap:10px;}
  .nl-val{display:flex;align-items:center;gap:13px;background:var(--card);border:.5px solid var(--line);
       border-radius:14px;padding:15px 16px;}
  .nl-val-ico{font-size:22px;flex-shrink:0;}
  .nl-val-txt{font-size:14px;color:var(--muted);}
  .nl-val-txt b{font-family:'PT Serif',Georgia,serif;color:var(--ink);font-weight:700;}

  /* Final CTA */
  .nl-final{text-align:center;padding:44px 30px 30px;background:linear-gradient(160deg,#FBF7EF,#F1E9D8);
         border-top:.5px solid var(--line);}
  .nl-final-candle{width:70px;height:94px;margin:0 auto 18px;position:relative;}
  .nl-final-title{font-family:'PT Serif',Georgia,serif;font-size:26px;font-weight:700;margin-bottom:10px;}
  .nl-final-title em{font-style:italic;color:var(--ac);}
  .nl-final-sub{font-size:14.5px;color:var(--muted);margin-bottom:22px;line-height:1.55;}

  .nl-footer{text-align:center;padding:22px;font-size:11.5px;color:var(--soft);}
  .nl-foot-link{background:none;border:none;cursor:pointer;color:var(--ac);font-weight:500;
             font-family:'Onest',sans-serif;font-size:11.5px;text-decoration:none;padding:0;}

  /* Flicker */
  @keyframes nlFlicker{0%,100%{transform:scale(1) translateY(0);opacity:1;}50%{transform:scale(1.06) translateY(-2px);opacity:.82;}}
  .nl-candle-svg ellipse[fill="url(#flame)"]{animation:nlFlicker 2.2s infinite ease-in-out;transform-origin:center bottom;}
  .nl-candle-svg{width:100%;height:100%;filter:drop-shadow(0 0 18px rgba(233,169,73,.35));}
</style>

<div class="nl-outer">
<div class="nl-root">

  <!-- NAV -->
  <div class="nl-nav">
    <div class="nl-nav-logo">PARAQTA</div>
    <div class="nl-nav-right">
      <button class="nl-nav-link" data-action="enter-guest-target" data-target="catalog">Кітапхана</button>
      <button class="nl-nav-cta" data-action="show-login">Кіру</button>
    </div>
  </div>

  <!-- HERO -->
  <section class="nl-hero">
    <div class="nl-hero-candle">
      <div class="nl-hero-glow"></div>
      <svg class="nl-candle-svg" viewBox="0 0 90 120" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="wax" x1="0" x2="1" y1="0" y2="0"><stop offset="0%" stop-color="#D8B987"/><stop offset="50%" stop-color="#C9A96E"/><stop offset="100%" stop-color="#8B5E34"/></linearGradient>
          <radialGradient id="flame" cx="0.5" cy="0.6" r="0.6"><stop offset="0%" stop-color="#FFF8E0"/><stop offset="40%" stop-color="#FFE599"/><stop offset="80%" stop-color="#E9A949"/><stop offset="100%" stop-color="#8B5E34" stop-opacity="0.6"/></radialGradient>
        </defs>
        <ellipse cx="45" cy="115" rx="20" ry="2.5" fill="#8B5E34" opacity="0.22"/>
        <rect x="30" y="44" width="30" height="69" rx="3.5" fill="url(#wax)"/>
        <rect x="33" y="46" width="3.5" height="64" rx="1.5" fill="#FBF7EF" opacity="0.4"/>
        <line x1="45" y1="44" x2="45" y2="32" stroke="#1C1A16" stroke-width="1.6"/>
        <ellipse cx="45" cy="23" rx="10.5" ry="16" fill="url(#flame)"/>
        <ellipse cx="45" cy="25" rx="4.5" ry="9" fill="#FFF8E0"/>
      </svg>
    </div>
    <div class="nl-hero-eyebrow">«Оқысаңыз, балалар! Шамнан шырақ жағылар…» — Ыбырай Алтынсарин</div>
    <h1 class="nl-hero-title">Кітап оқитын уақ —<br><em>өмірдің ең бір сәулелі сәттері.</em></h1>
    <p class="nl-hero-sub">Оқу машығы – үздіксіз үйренудің тетігі. Көкірегі ояу, көзі ашық ұлт қалыптастыру – біздің діттем.</p>
    <button class="nl-hero-cta" data-action="show-login">Telegram арқылы бастау →</button>
    <div class="nl-hero-trust">Тегін · 1 минутта кіресің</div>
    <div style="margin-top:6px;">
      <button class="nl-hero-sec" data-action="enter-guest-target" data-target="catalog">📚 Кітапхананы шолып шығу</button>
    </div>
  </section>

  <!-- STATS -->
  <div class="nl-stats">
    <div class="nl-stat"><div class="nl-stat-num">${users}</div><div class="nl-stat-lbl">оқырман</div></div>
    <div class="nl-stat"><div class="nl-stat-num">${books}</div><div class="nl-stat-lbl">кітап</div></div>
    <div class="nl-stat"><div class="nl-stat-num">${pages}</div><div class="nl-stat-lbl">оқылған бет</div></div>
  </div>

  <!-- MISSION -->
  <section class="nl-mission">
    <div class="nl-mission-text">
      «Тындырымды тұлғалардың ортақ олжасы – оқу. PARAQTA – <b>"өмір" атты кітабыңның әр парағына мән бітіретін</b> құрал.»
    </div>
    <div class="nl-mission-sig">— Ердәулет Аянұлы, негізін қалаушы</div>
  </section>

  <!-- HOW IT WORKS -->
  <section class="nl-sec">
    <div class="nl-sec-eyebrow">Қалай қолдансам болады?</div>
    <h2 class="nl-sec-title">Қарапайым <em>үш қадам</em></h2>
    <div class="nl-steps">
      <div class="nl-step">
        <div class="nl-step-ico">📚</div>
        <div class="nl-step-body"><h4>1. Тап</h4><p>Оқитын кітабыңды кітапханадан тауып, тізімге қос. Таппай жатсаң, өзің де қоса аласың.</p></div>
      </div>
      <div class="nl-step">
        <div class="nl-step-ico">🕯</div>
        <div class="nl-step-body"><h4>2. Оқы</h4><p>Үздіксіз оқу, дамылсыз даму — жан сарайыңдағы ілім шырағын жағады.</p></div>
      </div>
      <div class="nl-step">
        <div class="nl-step-ico">📈</div>
        <div class="nl-step-body"><h4>3. Өс</h4><p>Прогресің, streak, жылдық мақсатыңның статистикасы, саны мен сапасы көз алдыңда тұрады.</p></div>
      </div>
    </div>
  </section>

  <!-- ПАРАҚТАУ -->
  <section class="nl-sec" style="padding-top:6px;">
    <div class="nl-sec-eyebrow">Парақтау</div>
    <h2 class="nl-sec-title">Тек <em>пайдалы</em> ағын</h2>
    <p class="nl-sec-lead">Уақыт ұрлайтын шудан алыста — мұнда тек кітап туралы пікір мен рецензия.</p>
    <div class="nl-feed-prev">
      <div class="nl-fp-row">
        <div class="nl-fp-av">АЖ</div>
        <div class="nl-fp-mid"><div class="nl-fp-name">Аружан</div><div class="nl-fp-book">«Абай жолы» · М. Әуезов</div><div class="nl-fp-text">Бұл кітап — ұлт жадының айнасы. Әр бетінен дала тынысын сезесің...</div></div>
      </div>
      <div class="nl-fp-row">
        <div class="nl-fp-av">Дә</div>
        <div class="nl-fp-mid"><div class="nl-fp-name">Дәурен</div><div class="nl-fp-book">«Көксерек» · М. Әуезов</div><div class="nl-fp-text">Бір отырыста оқып шықтым. Қасқырдың тағдыры — адамзатқа сабақ.</div></div>
      </div>
    </div>
    <p class="nl-fp-note">✍️ Өзің оқыған кітапқа рецензия жазып, басқалармен бөліс.</p>
  </section>

  <!-- VALUE -->
  <section class="nl-sec" style="padding-top:6px;">
    <div class="nl-sec-eyebrow">Нәтижесінде</div>
    <h2 class="nl-sec-title">Дамылсыз дамитын, <em>ойлы оқырман боп шығасың</em></h2>
    <div class="nl-vals">
      <div class="nl-val"><div class="nl-val-ico">🔥</div><div class="nl-val-txt"><b>Мызғымас әдет</b> — күнделікті оқу рухани қажеттілігіңе айналады.</div></div>
      <div class="nl-val"><div class="nl-val-ico">📊</div><div class="nl-val-txt"><b>Айқын прогресс</b> — парақтаған әрбір бетің есепке алынып, дамуыңды көрсетеді.</div></div>
      <div class="nl-val"><div class="nl-val-ico">🤝</div><div class="nl-val-txt"><b>Пікірлес орта</b> — өзіңмен мүдделес, көкірегі ояу жандармен біргесің.</div></div>
      <div class="nl-val"><div class="nl-val-ico">🎯</div><div class="nl-val-txt"><b>Нақты нәтиже</b> — жылына ондаған кітапты еш қиындықсыз тауысасың.</div></div>
    </div>
  </section>

  <!-- FINAL CTA -->
  <section class="nl-final">
    <div class="nl-final-candle">
      <svg class="nl-candle-svg" viewBox="0 0 90 120" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="45" cy="115" rx="20" ry="2.5" fill="#8B5E34" opacity="0.22"/>
        <rect x="30" y="44" width="30" height="69" rx="3.5" fill="url(#wax)"/>
        <line x1="45" y1="44" x2="45" y2="32" stroke="#1C1A16" stroke-width="1.6"/>
        <ellipse cx="45" cy="23" rx="10.5" ry="16" fill="url(#flame)"/>
        <ellipse cx="45" cy="25" rx="4.5" ry="9" fill="#FFF8E0"/>
      </svg>
    </div>
    <div class="nl-hero-eyebrow" style="font-family:'PT Serif',Georgia,serif;font-style:italic;font-size:13px;color:var(--soft);letter-spacing:0;font-weight:400;margin-bottom:16px;">«Қазақ үшін шам қылған жүрек майын» — Сұлтанмахмұт Торайғыров</div>
    <h2 class="nl-final-title">Шамыңды <em>жағайық</em></h2>
    <p class="nl-final-sub">Ілім шырағын жағайық. Бүгін оқыған бір бет — ертең оқитын он бетке жол.</p>
    <button class="nl-hero-cta" data-action="show-login">Telegram арқылы бастау →</button>
    <div class="nl-hero-trust">Тегін · картасыз</div>
    <div style="margin-top:8px;">
      <button class="nl-hero-sec" data-action="enter-guest-target" data-target="catalog">📚 Кітапхананы шолып шығу</button>
    </div>
  </section>

  <div class="nl-footer">
    PARAQTA © 2026 · <button class="nl-foot-link" data-action="show-login">Жан дос</button> · <a class="nl-foot-link" href="https://t.me/paraqta_oqy" target="_blank" rel="noopener">Telegram арна</a>
  </div>

</div>
</div>
  `;
}
